/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ResponseGetDiscountInformation } from '../models';
/**
 * DiscountApi - axios parameter creator
 * @export
 */
export const DiscountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get discount information
         * @param {string} discountCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountInformation: async (discountCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discountCode' is not null or undefined
            assertParamExists('getDiscountInformation', 'discountCode', discountCode)
            const localVarPath = `/discount/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (discountCode !== undefined) {
                localVarQueryParameter['discountCode'] = discountCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiscountApi - functional programming interface
 * @export
 */
export const DiscountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiscountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get discount information
         * @param {string} discountCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscountInformation(discountCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetDiscountInformation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscountInformation(discountCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiscountApi.getDiscountInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiscountApi - factory interface
 * @export
 */
export const DiscountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiscountApiFp(configuration)
    return {
        /**
         * 
         * @summary Get discount information
         * @param {string} discountCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscountInformation(discountCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetDiscountInformation> {
            return localVarFp.getDiscountInformation(discountCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DiscountApi - interface
 * @export
 * @interface DiscountApi
 */
export interface DiscountApiInterface {
    /**
     * 
     * @summary Get discount information
     * @param {string} discountCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApiInterface
     */
    getDiscountInformation(discountCode: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetDiscountInformation>;

}

/**
 * DiscountApi - object-oriented interface
 * @export
 * @class DiscountApi
 * @extends {BaseAPI}
 */
export class DiscountApi extends BaseAPI implements DiscountApiInterface {
    /**
     * 
     * @summary Get discount information
     * @param {string} discountCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscountApi
     */
    public getDiscountInformation(discountCode: string, options?: RawAxiosRequestConfig) {
        return DiscountApiFp(this.configuration).getDiscountInformation(discountCode, options).then((request) => request(this.axios, this.basePath));
    }
}

